import PropTypes from 'prop-types';

const FacebookIcon = ({ size, className, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size || '1em'}
    height={size || '1em'}
    fill="currentColor"
    className={className}
    style={style}
  >
    <path d="M17.525 9H14V7c0-1.032.084-1.682 1.563-1.682h1.868V2.138C16.522 2.044 15.608 1.998 14.693 2 11.98 2 10 3.657 10 6.699V9H7v4l3-.001V22h4v-9.003l3.066-.001L17.525 9z" />
  </svg>
);

FacebookIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  style: PropTypes.object
};

export { FacebookIcon };
